import { render } from "./ErrorBalloon.vue?vue&type=template&id=8629eb66"
import script from "./ErrorBalloon.vue?vue&type=script&lang=js"
export * from "./ErrorBalloon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__